/** @format */

import React, { useState, useEffect, useRef } from 'react';
import {
  PageContainer,
  FilterPod,
  TableComponents,
  LoadingPage,
  ExportButton,
  Icons,
  PriceLabel,
} from 'components';
import { Link as RouterLink } from 'react-router-dom';
import { toFilterVOS } from 'components/FilterPod';
import { useStyles } from './style';
import { Grid, Button, Typography, Box } from '@mui/material';
import { enifyDateTime } from 'utility';
import useCustomHook from './hooks';
import { useGuildsList, useExportFile } from 'hooks';
import InitFilters from './constants/InitFiltering';
import Services from './services/IncomeByGuildServices';
import { columns, generateData } from './components/Columns';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import axios from 'axios';
import { useCurrencyUnit } from 'hooks';

import { getExportServiceProviderUrl } from 'URLs';
const AssignedDelegation = () => {
  // -- STATES --//
  const tableRef = useRef();
  const {
    loading,
    setLoading,
    totalIncome,
    setTotalIncome,
    filterParams,
    setFilterParams,
    size,
    setSize,
    page,
    setPage,
  } = useCustomHook();
  // const [size, setSize] = useState(10);

  // --HOOKS--//
  const classes = useStyles();
  const actionsList = getDynamicObjectAction([
    'guildsIncomeFinancialPage',
    'exportGuildsIncomeDetailFinancialBtn',
  ]);
  const currencyText = useCurrencyUnit(false);

  const { businessGuildsList, getGuildsList, guildListLoading } = useGuildsList();
  const [filters, setFilters] = useState(InitFilters(businessGuildsList , currencyText));
  const { downloadFile, isExporting } = useExportFile({
    url: getExportServiceProviderUrl(),
    filename: 'income-report-by-guilds',
  });

  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  useEffect(() => {
    if (actionsList['guildsIncomeFinancialPage']) {
      getGuildsList();
    } else {
    }
  }, []);

  useEffect(() => {
    setFilters(InitFilters(businessGuildsList));
  }, [businessGuildsList]);

  // --API REQUESTS--//
  const getIncomes = async (query) => {
    try {
      setLoading(true);

      let orderBy = [];
      let orderByName = null;

      switch (query?.orderBy?.field) {
        case 'id':
          orderByName = 'شناسه صنف';
          break;
        case 'name':
          orderByName = 'نام صنف';
          break;
        case 'income':
          orderByName = 'مجموع مبلغ درآمد';
          break;
        default:
          break;
      }
      if (orderByName && orderBy.length === 0) {
        orderBy = [
          {
            name: orderByName,
            isDesc: query?.orderDirection === 'desc',
          },
        ];
      }

      const filter = toFilterVOS([...filters]);

      const params = {
        page: query ? query?.pageNumber : page,
        pageSize: query?.pageSize || size,
        startDate: enifyDateTime(filters[0]?.value?.start?.format('jYYYY/jMM/jDD 00:00:00')),
        endDate: enifyDateTime(filters[0]?.value?.end?.format('jYYYY/jMM/jDD 23:59:59')),
      };

      const data = {
        filterVOS: filter ?? [],
        parentParams: [],

        orderByElementVOS: orderBy ?? [],
      };

      setFilterParams({ data, params });

      const res = await Services.getIncome(data, params);

      let list = [];
      if (res.result) {
        list = generateData(res.result?.rows, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
          startDate: filters?.[0]?.value?.start,
          endDate: filters?.[0]?.value?.end,
        });

        setTotalIncome(computeTotal(list) ?? 0);
      }

      setLoading(false);

      const d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.result?.totalCount,
      };
      return d; // passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  const onExport = (type, index) => {
    const types = ['xls', 'csv'];
    downloadFile(types[index], filterParams?.data, filterParams?.params);
  };

  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0);
    setSize(10);
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100);
  };
  const computeTotal = (guildIncomes = []) => {
    let total = 0;
    guildIncomes.forEach((v) => {
      total += v?.income;
    });
    return total;
  };

  const hint =
    'در این بخش می‌توانید گزارش درآمد تجمیعی کسب‌وکار را به تفکیک حساب‌های تفصیلی کسب‌وکار (صنف) مشاهده کنید.';

  const SeeDetailBtn = ({ id, startDate, endDate }) => {
    const classes = useStyles();
    return (
      <RouterLink
        to={`/Invoice?guild=${id}&startDate=${enifyDateTime(
          startDate?.format('jYYYY/jMM/jDD'),
        )}&endDate=${enifyDateTime(endDate?.format('jYYYY/jMM/jDD'))}&invoiceStatus=بسته شده`}
      >
        <Button
          startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
          variant="contained"
          className={classes.expandBtn}
        >
          جزئیات
        </Button>
      </RouterLink>
    );
  };

  return (
    <PageContainer
      title="گزارش درآمد بر اساس حساب تفصیلی"
      pageKey="incomeByGuild"
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.INCOME_BY_GUILDS}
      className={classes.root}
    >
      {guildListLoading && actionsList['guildsIncomeFinancialPage'] ? (
        <LoadingPage />
      ) : (
        <>
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="end"
              alignItems="flex-end"
              style={{ marginBottom: 16 }}
            >
              {actionsList['guildsIncomeFinancialPage'] && (
                <FilterButton setOpenFilterDialog={setOpenFilterDialog} filters={filters} />
              )}
              {actionsList['exportGuildsIncomeDetailFinancialBtn'] && (
                <ExportButton loading={isExporting} types={['xls', 'csv']} onExport={onExport} />
              )}
            </Box>
            <Box>
              {actionsList['guildsIncomeFinancialPage'] && (
                <FilterPod
                  filters={filters}
                  onChange={onFiltersChange}
                  openFilterDialog={openFilterDialog}
                  setOpenFilterDialog={setOpenFilterDialog}
                  handleCloseFilterDialog={handleCloseFilterDialog}
                />
              )}
            </Box>
          </Grid>
          {actionsList['guildsIncomeFinancialPage'] && currencyText && (
            <>
              <TableComponents
                data={getIncomes}
                columns={columns(actionsList, SeeDetailBtn, currencyText)}
                isLoading={loading}
                ref={tableRef}
                onChange={(ps) => {
                  setPage(ps?.pageNumber);
                  setSize(ps?.pageSize);
                  return getIncomes(ps);
                }}
              />
              <Grid container item xs={12} justifyContent="flex-start" className={classes.totalIncome}>
                <Grid item>
                  <Typography>مجموع درآمد حساب‌های تفصیلی:</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.totalIncomePrice}>
                    <PriceLabel amount={totalIncome ?? 0} currency={currencyText} />
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}
        </>
      )}
    </PageContainer>
  );
};

// See detail for every row

export default AssignedDelegation;
